import { render, staticRenderFns } from "./SetVideoThumbnail.vue?vue&type=template&id=49e94884"
import script from "./SetVideoThumbnail.vue?vue&type=script&lang=js"
export * from "./SetVideoThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports